import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApplicationState, getUserProduct } from '../store/reducers';
import * as ProductsActions from '../store/actions/products.actions';
import { OnDestroyHookDirective } from '../shared/hooks';
import { LabelIdentifiers, PlcCodes } from '@dch/products-business-logic';
import { Observable } from 'rxjs';
import { savePiiNsp } from '../shared/pii/pii.utils';

@Injectable()
export class NspDeeplinkGuard
  extends OnDestroyHookDirective
  implements CanActivate
{
  constructor(
    private router: Router,
    private _store: Store<ApplicationState>,
  ) {
    super();
  }

  canActivate(): Observable<boolean> {
    this._store.dispatch(new ProductsActions.GetProducts());
    return new Observable<boolean>(() =>
      this.addSubscription(
        this._store.select(getUserProduct).subscribe(
          (data) => {
            if (
              data &&
              ((data.packs && data.packs.length > 0) ||
                (data.outOfPacks && data.outOfPacks.length > 0))
            ) {
              const allPacks = [].concat(
                ...data.packs.map((item: any) => item.coreProducts),
                ...data.packs.map((item: any) => item.nonCoreProducts),
                ...data.outOfPacks.map((item: any) => item.coreProducts),
                ...data.outOfPacks.map((item: any) => item.nonCoreProducts),
              );

              const NSPArrayProduct = allPacks.filter(
                (item) => item.plc === PlcCodes.NSP,
              );
              const countNSP = NSPArrayProduct.length;

              const ctaProductNSPInPacks = data.packs.filter((pack) =>
                pack.ctaProducts?.find((cta) => cta.plcs?.includes('NSP')),
              );
              const ctaProductNSPOutOfPacks = allPacks.filter(
                (product) =>
                  product.ctaProducts?.find((cta) =>
                    cta.plcs?.includes('NSP'),
                  ) && product.labelIdentifier !== LabelIdentifiers.FON,
              );
              const ctaProductNSP = [].concat(
                ctaProductNSPInPacks,
                ctaProductNSPOutOfPacks,
              );
              const productWithNSPCtaCount = ctaProductNSP.length;

              if (countNSP === 0 && productWithNSPCtaCount === 1) {
                savePiiNsp(this.getNSPPayload(ctaProductNSP[0]));
                this.router.navigate(['/nspActivation']);
              } else if (countNSP === 1 && productWithNSPCtaCount === 0) {
                savePiiNsp(this.getNSPPayload(NSPArrayProduct[0]));
                this.router.navigate(['/nspManage']);
              } else {
                this.router.navigate(['/overview']);
              }
              return true;
            } else {
              this.router.navigate(['/overview']);
              return false;
            }
          },
          (error) => {
            console.error(error);
            this.router.navigate(['/overview']);
            return false;
          },
        ),
      ),
    );
  }

  getNSPPayload(product) {
    let payload = {};
    if (product.packId) {
      payload = {
        packId: product.packId,
      };
    } else {
      if (product.addressKey) {
        payload = {
          productId: product.productId,
          plcList: [PlcCodes.FI],
        };
      } else {
        payload = {
          plcList: [PlcCodes.MV, PlcCodes.MI],
        };
      }
    }
    return payload;
  }
}
